export type PositionStatus = 1 | 2 | 3 | 4 | 5;

export const PositionStatusMap: {
  [P in PositionStatus]: { name: string };
} = {
  1: {
    name: '出資中',
  },
  2: {
    name: 'リース延長',
  },
  3: {
    name: 'リース満了',
  },
  4: {
    name: '案件終了',
  },
  5: {
    name: '中途解約',
  },
};
